module.exports = __webpack_public_path__ + "img/brand_01.44b17184.png";